<div class="flex flex-col items-center justify-center public-container">
  @if (showTooManyTriesNotification) {
    <pin-notification type="alert" class="w-full">
      Too many attempts. Please try again later.
    </pin-notification>
  }

  <form class="flex flex-col gap-10 w-full" [formGroup]="usernameForm" (ngSubmit)="requestVerificationCode()">
    <div class="flex flex-col items-center justify-center gap-4">
      <div class="flex flex-col gap-2 w-full">
        <div class="dcp-h1">Forgot Password</div>
        <div class="flex items-center justify-start dcp-body" id="user.verification.subtitle">Please enter your username.</div>
      </div>

      <div class="flex flex-col w-full">
        <mat-form-field appearance="outline" id="user.credentials.username" class="w-full">
          <mat-label>Username</mat-label>

          <input matInput placeholder="Username" type="text" formControlName="username" maxlength="128" i18n-placeholder="@@username-placeholder"
                 pinAutoFocus>
          @if (usernameForm.controls['username'].hasError('required')) {
            <mat-error id="username.required" i18n="@@registration.username.required">
              This field is <strong>required</strong>
            </mat-error>
          }

          @if (usernameForm.controls['username'].hasError('nonAsciiPrintable')) {
            <mat-error>
              This field cannot contain invalid characters.
            </mat-error>
          }
        </mat-form-field>
         <pin-button buttonStyle="link" buttonId="forgot-username-link" [buttonType]="buttonType.DEFAULT" redirectUrl="/forgot-username">Forgot username?</pin-button>
      </div>
    </div>

    <div class="flex flex-col items-center justify-center gap-4">
      <pin-button buttonStyle="filled" class="w-full" buttonId="forgot-password-continue-button" [isDisabled]="loading">CONTINUE</pin-button>
      <pin-button buttonStyle="icon-link" buttonId="forgot-password-back-to-login-button" [buttonType]="buttonType.DEFAULT" iconName="arrow_back" redirectUrl="/login">
	      Back to login
      </pin-button>
    </div>
  </form>
</div>

@if (loading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
